import { extractErrorMessage } from '@/services/utils';

export const buildStoreError = (error, fallbackMessage) => {
	const built = new Error(extractErrorMessage(error, fallbackMessage));
	built.code = error?.response?.data?.code || null;
	return built;
};
